/*
 *
 * TenantForm14852
 *
 */

import {TenantForm} from 'pages/Requests/TenantView';
import {formField} from 'domain/typeConstants/form';
import * as entity from 'domain/Data/constants';
import * as entities from 'domain/Data/constants';
import {departmentCalculatedValue, departmentVisibleOptions} from "pages/Requests/common/fields";
import {
    CARRYING_OUT_WORKS,
    ON_CAR_ENTRY,
    ON_PASS_BLOCKING,
    ON_PASS_MAKING,
    ON_PROPERTY_BRINGING,
    ON_PROPERTY_REMOVAL,
    ON_VISIT,
    SERVICE
} from "domain/Data/RequestType/constants";
import {ACCEPTED} from "domain/Data/RequestStatus/constants";


export class TenantForm14852 extends TenantForm {

    getFields() {
        const fields = super.getFields();

        const typeIndex = fields.findIndex((field) => field.name === 'type');
        fields[typeIndex].filters = ['AvailableRequestsTypes14852']
        fields[typeIndex].orderBy = 'order'
        fields[typeIndex].initialValue = (values, mode, user) => {
            if (mode === 'add' && user.defaultRequestTypeId) {
                return user.defaultRequestTypeId;
            }
            return values.type;
        }
        fields[typeIndex].clearErrorsOnChange = true

        const companyIndex = fields.findIndex((field) => field.name === 'company');
        const company = {...fields[companyIndex]}
        company.visible = true;
        company.disabled = true;
        company.rowBreakBefore = true;
        fields.splice(companyIndex, 1)

        const visitorFullNameIndex = fields.findIndex((field) => field.name === 'visitorFullName');
        fields[visitorFullNameIndex].label = "Фамилия Имя"
        fields[visitorFullNameIndex].required = (values) => [ON_PASS_MAKING, ON_PASS_BLOCKING, ON_PROPERTY_BRINGING, ON_PROPERTY_REMOVAL, ON_VISIT]
            .includes(values.type)
        fields[visitorFullNameIndex].helperText = (values) => {
            if (values.type === ON_VISIT) return 'фамилия, имя гостя'
            else if (values.type === ON_CAR_ENTRY) return 'фамилия, имя водителя'
            else if ([ON_PROPERTY_BRINGING, ON_PROPERTY_REMOVAL, CARRYING_OUT_WORKS].includes(values.type))
                return 'фамилия, имя сотрудника'
        }
        fields.splice(visitorFullNameIndex + 1, 0, company)

        const department = {
            name: 'department',
            type: formField.SELECT,
            entityName: entity.DEPARTMENTS,
            label: 'Здание',
            visible: true,
            required: true,
            initialValue: (values, mode, user) => mode === 'add' && user.departmentId,
            calculatedValue: departmentCalculatedValue,
            visibleOptions: departmentVisibleOptions,
        }

        fields.splice(visitorFullNameIndex + 2, 0, department)

        const nonstandardCarNumberIndex = fields.findIndex((field) => field.name === 'nonstandardCarNumber');
        fields[nonstandardCarNumberIndex].visible = (values) => [ON_CAR_ENTRY, CARRYING_OUT_WORKS].includes(values.type) && !values.isGroupRequest

        const carNumberIndex = fields.findIndex((field) => field.name === 'carNumber');
        fields[carNumberIndex].visible = (values) => [ON_CAR_ENTRY, CARRYING_OUT_WORKS].includes(values.type) && !values.isGroupRequest

        const carModelTextIndex = fields.findIndex((field) => field.name === 'carModelText');
        fields[carModelTextIndex].visible = (values) => [ON_CAR_ENTRY, CARRYING_OUT_WORKS].includes(values.type) && !values.isGroupRequest

        const parkingIndex = fields.findIndex((field) => field.name === 'parking');
        fields[parkingIndex].visible = (values) => [ON_CAR_ENTRY, CARRYING_OUT_WORKS].includes(values.type) && !values.isGroupRequest
        fields[parkingIndex].required = (values) => values.type === ON_CAR_ENTRY
        fields[parkingIndex].visibleOptions = (currentValues, initialValues, mode, user, entities) => {
            if (currentValues.type === ON_CAR_ENTRY || currentValues.type === CARRYING_OUT_WORKS) {
                if (currentValues.company) {
                    const company = entities
                        .get(entity.COMPANIES)
                        .get(currentValues.company);
                    const companyParkings = company ? company.get(entity.PARKINGS) || [] : [];

                    return entities.get(entity.PARKINGS)
                        .filter((parking) => companyParkings.includes(parking.id))
                        .map((parking) => parking.id);
                }
            }
        }

        const materialValuesDataIndex = fields.findIndex((field) => field.name === 'materialValuesData');
        fields[materialValuesDataIndex].helperText = 'наименование, кол-во, ед.изм., вид упаковки'

        const companyNameIndex = fields.findIndex((field) => field.name === 'companyName');
        fields[companyNameIndex].visible = (values) => values.type === CARRYING_OUT_WORKS

        const longtermIndex = fields.findIndex((field) => field.name === 'longterm');
        fields[longtermIndex].visible = (values) => values.type !== SERVICE && values.type !== ON_PROPERTY_BRINGING && values.type !== ON_PROPERTY_REMOVAL
            && values.type !== ON_PASS_MAKING && values.type !== ON_PASS_BLOCKING


        const parkingPlaceIndex = fields.findIndex((field) => field.name === 'parkingPlace');
        fields[parkingPlaceIndex].visible = (values) => values.type === ON_CAR_ENTRY || values.type === CARRYING_OUT_WORKS

        const workTypeIndex = fields.findIndex((field) => field.name === 'workType');
        fields[workTypeIndex].rowBreakAfter = false

        const vozdvizhenkaTime = {
            name: 'vozdvizhenkaTime',
            type: formField.SELECT,
            entityName: entities.TIMES,
            label: 'Время выполнения',
            visible: (values) => values.type === CARRYING_OUT_WORKS,
        }

        fields.splice(workTypeIndex + 1, 0, vozdvizhenkaTime)

        const groupRequestVisitorsDataIndex = fields.findIndex((field) => field.name === 'groupRequestVisitorsData');
        fields[groupRequestVisitorsDataIndex].helperText = 'Фамилия Имя, № авто (формат: х111хх77) и марка пишутся в одну строку, каждый посетитель пишется с новой строки'

        const fileIndex = fields.findIndex((field) => field.name === 'file');
        fields[fileIndex].visible = (values) => values.type === SERVICE || values.type === CARRYING_OUT_WORKS

        const statusIndex = fields.findIndex((field) => field.name === 'status');
        fields[statusIndex].calculatedValue = (values, mode) => {
            if (mode === 'add' || mode === 'copy') {
                return ACCEPTED
            }
        }

        return fields;
    }

}



